import React, { Component } from "react";
import Cookies from "js-cookie";
import { changeLang } from "../../actions/langAction";
import { connect } from "react-redux";
import Api from "../../services/ServiceApi";
import moment from "moment";

function setCookies(job_id, job_progress_id, job_type_id, job_status) {
  Cookies.set("job_id", job_id);
  Cookies.set("job_progress_id", job_progress_id);
  Cookies.set("job_type_id", job_type_id);
  Cookies.set("job_status", job_status);

  if (Cookies.get("companyid") === 3 || Cookies.get("companyid") === "3") {
    window.open(
      `/MaxiOperation/full_detail_job/${Cookies.get("companyid")}/${Cookies.get(
        "operator_id"
      )}/${Cookies.get("project_id")}/${job_id}`
    );
  } else {
    setTimeout(function () {
      window.location.assign(`/MaxiOperation/full_detail_job`);
    }, 100);
  }
}
class CardJob extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.myRef = React.createRef();
    this.state = { scrollTop: 0, data_translate: [], factupdate: false };
  }

  onScroll = () => {
    const scrollY = window.scrollY; //Don't get confused by what's scrolling - It's not the window
    const scrollTop = this.myRef.current.scrollTop;
    console.log(
      `onScroll, window.scrollY: ${scrollY} myRef.scrollTop: ${scrollTop}`
    );
    this.setState({
      scrollTop: scrollTop,
    });
  };

  async componentDidMount() {
    this.setState({
      data_translate: this.props.data_translate,
      factupdate: true,
    });
  }

  render() {
    const { list, sel_id } = this.props;
    const bgcolor = list.job_id === sel_id ? "yellow" : "white";
    // const checkclick = list.job_id === sel_id ? console.log(list.job_id) : null;

    return (
      <div
        className="card-list-job mb-2"  
        style={{ background: bgcolor, cursor: "pointer", width: "586px" }}
        onScroll={this.onScroll}
        id={list.job_id}
        onClick={() =>
          setCookies(
            list.job_id,
            list.job_progress_id,
            list.job_type_id,
            list.job_status
          )
        }
      >
        <div className="row mb-2">
          <div className="col-6">
            <div className="row">
              <div className="col-sm-auto my-auto">
                <img src={Api.absoluteUrl("/icon/marker_job.svg")} alt="" />
              </div>
              <div className="col-sm-auto my-auto">
                <span
                  className="fs-14"
                >
                  {list.job_no}
                </span>
              </div>
            </div>
            <div className="row ml-4">
                <div className="col-12">
                  <h4>
                    <a
                      href={
                        Cookies.get("companyid") === 1 ||
                        Cookies.get("companyid") === "1" ///  companyid บางทีเก็บเป็น int บางทีเป้น String ถ้าจะเช็ครบกวนเพิ่ม || "" หรือ parseInt ด้วยเด้อครับ
                          ? `/MaxiOperation/full_detail_job`
                          : `/MaxiOperation/full_detail_job/${Cookies.get(
                              "companyid"
                            )}/${Cookies.get("operator_id")}/${Cookies.get(
                              "project_id"
                            )}/${list.job_id}`
                      }
                      className="font20 font-thai-b c-blue"
                    >
                      {list.location_name}
                    </a>
                  </h4>
                  <span className="font14 font-thai-i">{list.job_area_code}</span>
                </div>
            </div>
            

            {/* </div> */}
          </div>
          <div className="col-6 text-right">
            {list.priority_level === "3" ? (
              <span className="badge badge-pill badge-primary font-thai-b font14 mr-2">
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "status_high"
                      ]
                    }
                  </span>
                ) : null}{" "}
              </span>
            ) : null}
            {list.priority_level === "2" ? (
              <span className="badge badge-pill badge-warning font-thai-b font14 mr-2">
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "status_normal"
                      ]
                    }
                  </span>
                ) : null}{" "}
              </span>
            ) : null}
            {list.priority_level === "1" ? (
              <span className="badge badge-pill badge-success font-thai-b font14 mr-2">
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "status_low"
                      ]
                    }
                  </span>
                ) : null}{" "}
              </span>
            ) : null}
            <span className="badge badge-pill badge-secondary font-thai-sb font14 mr-2">
              {list.job_category_name}
            </span>

            {list.job_status === 2 ? (
              <span className="badge badge-pill badge-light on-process font-thai-b font14">
                <span className="dot-on-process mr-2"></span>
                {list.job_status_name}
              </span>
            ) : (
              <span className="badge badge-pill badge-light font-thai-b font14">
                {list.job_status_name}
              </span>
            )}
          </div>
        </div>
        <div className="row" style={{ marginLeft: "20px" }}>
          <div className="col-6" style={{ borderLeft: "2px solid #E8ECEF" }}>
            <div className="row" style={{ lineHeight: "20px" }}>
              <div
                className="col-5 font-thai-b font16"
                style={{ color: "#2c2c2c" }}
              >
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "asset_code"
                      ]
                    }
                  </span>
                ) : null}{" "}
              </div>
              <div className="col-7 font-thai-r font16">{list.asset_code}</div>
            </div>
            <div className="row" style={{ lineHeight: "20px" }}>
              <div
                className="col-5 font-thai-b font16"
                style={{ color: "#2c2c2c" }}
              >
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "asset_type"
                      ]
                    }
                  </span>
                ) : null}{" "}
              </div>
              <div className="col-7 font-thai-r font16">{list.asset_type}</div>
            </div>
            <div className="row" style={{ lineHeight: "20px" }}>
              <div
                className="col-5 font-thai-b font16"
                style={{ color: "#2c2c2c" }}
              >
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "asset_name"
                      ]
                    }
                  </span>
                ) : null}{" "}
              </div>
              <div className="col-7 font-thai-r font16">{list.asset_name}</div>
            </div>
          </div>
          <div className="col-6" style={{ borderLeft: "2px solid #E8ECEF" }}>
            <div className="row" style={{ lineHeight: "20px" }}>
              <div
                className="col-5 font-thai-b font16"
                style={{ color: "#2c2c2c" }}
              >
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "inform_date"
                      ]
                    }
                  </span>
                ) : null}{" "}
              </div>
              <div className="col-7 font-thai-r font16">
                {moment(list.emp_inform_date).format("DD/MM/YYYY HH:mm")}
              </div>
            </div>
            <div className="row" style={{ lineHeight: "20px" }}>
              <div
                className="col-5 font-thai-b font16"
                style={{ color: "#2c2c2c" }}
              >
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "inform_detail"
                      ]
                    }
                  </span>
                ) : null}{" "}
              </div>
              <div className="col-7 font-thai-r font16">
                <span style={{ wordWrap: "break-word", width: "100%" }}>
                  {" "}
                  {list.inform_detail}{" "}
                </span>
              </div>
            </div>
            <div className="row" style={{ lineHeight: "20px" }}>
              <div
                className="col-5 font-thai-b font16"
                style={{ color: "#2c2c2c" }}
              >
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "ma_period"
                      ]
                    }
                  </span>
                ) : null}{" "}
              </div>
              <div className="col-7 font-thai-sb font16 c-blue">
                {" "}
                {list.ma_time_start === null ? "" : list.ma_time_start}
                {" - "}
                {list.ma_time_start === null ? "" : list.ma_time_end}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.lang,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(CardJob);
